module.exports = __webpack_public_path__ + "img/home-historical-archive.jpg?a285428290f5bfcceee3b79d06e28356";